module.exports = __webpack_public_path__ + "static/media/charmap_1.532d6d42.ico";